var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSourcingThemeLevelTwo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M8 2.4 5.847 4.554 8 6.708l2.154-2.154zm0 6.893-2.153 2.154L8 13.6l2.154-2.153zm3.447-3.447L9.293 8l2.154 2.154L13.6 8zm-6.893.001L2.4 8l2.154 2.153L6.708 8z"
})));
export default SvgSourcingThemeLevelTwo;